"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = getCookie;
exports.setCookie = setCookie;
const enums_1 = require("../enums");
const internal_1 = require("../constants/internal");
function getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    let result = '';
    for (const element of ca) {
        const trimmedElement = element.replace(/\s+/, '');
        if (trimmedElement.indexOf(name) === 0) {
            result = trimmedElement.substring(name.length, trimmedElement.length);
            break;
        }
    }
    return result;
}
function setCookie(options) {
    const { name, value, sameSite = enums_1.SameSite.Lax, expiration } = options;
    let expires = '';
    if (expiration instanceof Date) {
        expires = `expires=${expiration.toUTCString()}`;
    }
    if (typeof expiration == 'boolean') {
        const now = new Date();
        now.setFullYear(now.getFullYear() + internal_1.COOKIE_MAX_AGE_IN_YEARS);
        expires = `expires=${now.toUTCString()}`;
    }
    const path = 'path=/';
    const cookieConfig = `domain=${location.hostname};SameSite=${sameSite};Secure`;
    document.cookie = `${name}=${value};${path};${cookieConfig};${expires}`;
}
